import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { gallery } from '../Data/Gallery'
import ImageGallery from 'react-image-gallery'
import { useMediaQuery } from 'react-responsive'
import { Container, Icon } from 'semantic-ui-react'

export default function FullGallery() {
  const { id } = useParams()
  const mobile = useMediaQuery({ query: '(max-width:1150px)' })
  const [, setCurrentOrientation] = useState(
    window.screen.orientation ? window.screen.orientation.type : 'portrait-primary'
  )

  const handleOrientationChange = async () => {
    try {
      if (window.screen.orientation) {
        const newOrientation =
          window.screen.orientation.type === 'portrait-primary'
            ? 'landscape-primary'
            : 'portrait-primary'
        await window.screen.orientation.lock(newOrientation)
        setCurrentOrientation(newOrientation)
      }
    } catch {
      // Ignored if device doesn't support orientation lock
    }
  }

  const items =
    id === 'all'
      ? gallery
      : gallery.filter(item => String(item.id) === String(id))

  const albumCategory = items[0]?.category || 'Gallery Album'

  return (
    <div id='fullGalleryPage'>
      {/* Top Bar for Fixed Navbar */}
      <div
        className='pageBanner'
        style={{ height: `${mobile ? '65px' : '90px'}`, backgroundColor: '#171717' }}
      />

      <section className='homeSection' style={{ paddingTop: '36px' }}>
        <Container>
          <div className='fullGalleryNavRow'>
            <Link to='/gallery' className='newsBackLink'>
              <Icon name='arrow left' /> Back to Photo Albums
            </Link>

            <div className='fullGalleryActions'>
              {id === 'all' ? (
                <Link to='/gallery' className='eventSecondaryBtn'>
                  <Icon name='grid layout' /> Browse by Category
                </Link>
              ) : (
                <Link to='/gallery/all' className='eventSecondaryBtn'>
                  <Icon name='images outline' /> View All Photos ({gallery.length})
                </Link>
              )}
            </div>
          </div>

          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <span className='sectionBadge'>Photo Collection</span>
            <h1 className='homeSectionTitle'>
              {id === 'all' ? 'All Community Photos' : albumCategory}
            </h1>
            <div className='goldAccentLine' style={{ margin: '10px auto 16px auto' }}></div>
            <p style={{ color: '#64748b' }}>
              Showing {items.length} {items.length === 1 ? 'photo' : 'photos'}
            </p>
          </div>

          <div className='imageGalleryWrapper'>
            <ImageGallery
              items={items}
              lazyLoad={true}
              showIndex={true}
              showBullets={items.length <= 20}
              showThumbnails={items.length <= 30}
              onScreenChange={handleOrientationChange}
            />
          </div>
        </Container>
      </section>
    </div>
  )
}
